import { type ValueOf } from '@/types';

export enum LineTypes {
	INPUT = 'input',
	SHARE = 'share',
}

export const RevenueFieldType = {
	RECOGNIZED: 'recognized',
	FORECASTED: 'forecasted',
} as const;

export type RevenueFieldTypeValue = ValueOf<typeof RevenueFieldType>;

export const columWidth = '15rem';
